import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Settings, 
  Package, 
  Tags, 
  Users, 
  Store, 
  Wrench,
  FileText,
  DollarSign,
  Box
} from 'lucide-react';

function AdminDashboard() {
  const navigate = useNavigate();

  const adminSections = [
    {
      title: 'Paramètres de la Bijouterie',
      description: 'Nom, logo, devise, coordonnées - Personnalisez votre entreprise',
      icon: Settings,
      path: '/admin/parametres',
      color: 'bg-indigo-600',
      hoverColor: 'hover:bg-indigo-700'
    },
    {
      title: 'Composants de Fabrication',
      description: 'Gérer les composants utilisés dans la fabrication (Fonte, Sertissage, Gravure, etc.)',
      icon: Wrench,
      path: '/admin/composants',
      color: 'bg-blue-500',
      hoverColor: 'hover:bg-blue-600'
    },
    {
      title: 'Catégories & Types',
      description: 'Gérer les catégories de bijoux et types de produits',
      icon: Tags,
      path: '/admin/categories-types',
      color: 'bg-purple-500',
      hoverColor: 'hover:bg-purple-600'
    },
    {
      title: 'Boutiques',
      description: 'Gérer les boutiques et leurs paramètres',
      icon: Store,
      path: '/boutiques',
      color: 'bg-green-500',
      hoverColor: 'hover:bg-green-600'
    },
    {
      title: 'Utilisateurs',
      description: 'Gérer les comptes utilisateurs et permissions',
      icon: Users,
      path: '/users',
      color: 'bg-orange-500',
      hoverColor: 'hover:bg-orange-600'
    },
    {
      title: 'Packaging',
      description: 'Gérer les types de packaging et emballages',
      icon: Package,
      path: '/admin/packaging',
      color: 'bg-pink-500',
      hoverColor: 'hover:bg-pink-600'
    },
    {
      title: 'Matières Premières',
      description: 'Types de matières premières (Or, Argent, Pierres, etc.)',
      icon: Box,
      path: '/admin/matieres',
      color: 'bg-yellow-500',
      hoverColor: 'hover:bg-yellow-600'
    },
    {
      title: 'Coûts & Tarifs',
      description: 'Gérer les coûts de fabrication et tarifs',
      icon: DollarSign,
      path: '/gestion-couts',
      color: 'bg-red-500',
      hoverColor: 'hover:bg-red-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center space-x-3 mb-2">
            <Settings className="h-10 w-10 text-indigo-600" />
            <h1 className="text-4xl font-bold text-gray-900">Administration</h1>
          </div>
          <p className="text-gray-600 text-lg">
            Gérez tous les paramètres et configurations de votre système ERP
          </p>
        </div>

        {/* Grid des sections admin */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {adminSections.map((section) => {
            const Icon = section.icon;
            return (
              <button
                key={section.path}
                onClick={() => navigate(section.path)}
                className={`${section.color} ${section.hoverColor} text-white rounded-xl p-6 shadow-lg transition-all duration-200 transform hover:scale-105 hover:shadow-xl text-left`}
              >
                <div className="flex items-start justify-between mb-4">
                  <Icon className="h-12 w-12" />
                  <div className="bg-white bg-opacity-20 rounded-lg px-3 py-1">
                    <span className="text-sm font-semibold">Admin</span>
                  </div>
                </div>
                <h3 className="text-xl font-bold mb-2">{section.title}</h3>
                <p className="text-white text-opacity-90 text-sm">
                  {section.description}
                </p>
              </button>
            );
          })}
        </div>

        {/* Statistiques rapides */}
        <div className="mt-12 bg-white rounded-xl shadow-lg p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Accès rapide</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-blue-50 rounded-lg p-4">
              <div className="text-blue-600 text-sm font-semibold mb-1">Composants</div>
              <div className="text-2xl font-bold text-gray-900">--</div>
            </div>
            <div className="bg-purple-50 rounded-lg p-4">
              <div className="text-purple-600 text-sm font-semibold mb-1">Catégories</div>
              <div className="text-2xl font-bold text-gray-900">--</div>
            </div>
            <div className="bg-green-50 rounded-lg p-4">
              <div className="text-green-600 text-sm font-semibold mb-1">Boutiques</div>
              <div className="text-2xl font-bold text-gray-900">--</div>
            </div>
            <div className="bg-orange-50 rounded-lg p-4">
              <div className="text-orange-600 text-sm font-semibold mb-1">Utilisateurs</div>
              <div className="text-2xl font-bold text-gray-900">--</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
